import { includes, isEmpty } from 'lodash';
import { DishFirstFoodItemsSegmentFragment, DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { UseExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';

// eslint-disable-next-line no-underscore-dangle -- Field from API.
export const getSegmentContentType = (segment: DishFirstFoodItemsSegmentFragment) =>
  segment.content.items[0].__typename;

export const getSegmentInfo = (
  filters: UseExploreUrl<DishFirstSegmentFilter>,
  segment: DishFirstFoodItemsSegmentFragment
) => {
  const isSpecialtySegment = !!filters.segmentFilters?.length;
  const isShefSegment = includes(filters.segmentFilters, DishFirstSegmentFilter.RecommendedShefs);
  const isCuisineFilterEmpty = isEmpty(filters.cuisineFilters);
  const contentType = getSegmentContentType(segment);
  const { layout } = segment;
  return {
    isSpecialtySegment,
    isShefSegment,
    isCuisineFilterEmpty,
    contentType,
    layout,
  };
};
